// ✅ React and Related
import React from 'react';

// ✅ Custom UI Components
import H3Text from '@Uilib/h3Text';

function ViewCreditNoteAddresses({
  currentCN,
  isReturnSlip,
}) {
  return (
    <div className="document-address-list">
      <div className="ant-row">
        {(currentCN?.ship_from_address_info || currentCN?.billing_address_info) && (
          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="document-address__left">
              <H3Text
                text={isReturnSlip ? 'Ship From' : 'Billing Address'}
                className="document-address__title"
              />
              {isReturnSlip ? (
                <React.Fragment>
                  <H3Text
                    text={currentCN?.ship_from_address_info?.address1}
                    className="document-address__details"
                  />
                  <H3Text
                    text={`${currentCN?.ship_from_address_info?.city}, ${currentCN?.ship_from_address_info?.state}, ${currentCN?.ship_from_address_info?.postal_code}, ${currentCN?.ship_from_address_info?.country}`}
                    className="document-address__details"
                  />
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <H3Text
                    text={currentCN?.billing_address_info?.address1}
                    className="document-address__details"
                  />
                  <H3Text
                    text={`${currentCN?.billing_address_info?.city}, ${currentCN?.billing_address_info?.state}, ${currentCN?.billing_address_info?.postal_code}, ${currentCN?.billing_address_info?.country}`}
                    className="document-address__details"
                  />
                </React.Fragment>
              )}
            </div>
          </div>
        )}
        {currentCN?.shipping_address_info && (
          <div className="ant-col-md-12 ant-col-xs-24">
            <div className="document-address__right">
              <H3Text
                text={isReturnSlip ? 'Ship To' : 'Shipping Address'}
                className="document-address__title"
              />
              {currentCN?.shipping_address_info && (
                <H3Text
                  text={currentCN.shipping_address_info.address1}
                  className="document-address__details"
                />
              )}
              {currentCN?.shipping_address_info?.address1 && (
                <H3Text
                  text={`${currentCN?.shipping_address_info?.city}, ${currentCN?.shipping_address_info?.state}, ${currentCN?.shipping_address_info?.postal_code}, ${currentCN?.shipping_address_info?.country}`}
                  className="document-address__details"
                />
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default ViewCreditNoteAddresses;